import $ from 'jquery';
import Modal from '../modules/Modal'
class Newsletter{

    constructor(){

        this.form = $('#subscribe-form');

        this.messageEl = $(".cc-subscribe-form__message");

        this.field = this.form.find('input[name="email"]');

        this.button = this.form.find('#subscribe-button');

        this.events();

    }

    events(){

        this.form.on('submit', this.submitForm.bind(this));
        
    }
    submitForm(event){

        event.preventDefault();

        const data = {
            email: this.field.val(),
            nonce: jpfSubscribe.nonce
        }

        this.disableForm();

        this.showprocessMessage();

        $.ajax({
            url: jpfSubscribe.ajax_url,
            type: 'POST',
            data: {
                action: 'jpf_subscribe',
                formData: JSON.stringify(data)
            },
            success: (response) => {

                if(response.success){

                    this.successMessage(response.message);

                } else {

                    this.failedMessage(response.message);

                }

            },
            error: (xhr, status, error) => {
                console.error('Subscribe failed:', error);
                this.failedMessage('An error occurred. Please try again later.');
            }
        });

    }
    successMessage(message){
        new Modal({
            header:"Subscribed",
            alert:true,
            content: message,
            confirm:{
                label:"Ok"
            }      
        })
        this.field.removeClass('error-field');
        this.field.addClass('success-field');
        this.removeprocessMessage();
        this.resetForm();

    }
    failedMessage(message){
        this.messageEl.text(message);
        this.field.removeClass('success-field');
        this.field.addClass('error-field');
        this.removeprocessMessage();
        this.resetForm();
    }
    resetForm(){

        setTimeout(() => {
            this.clearMessages();
            this.enableForm();
        }, 3000);

    }
    clearMessages(){
        this.field.val('');
        this.messageEl.text('');
        this.field.removeClass('error-field');
        this.field.removeClass('success-field');
    }
    disableForm(){
        this.form.find('input, button').prop('disabled', true);
    }
    enableForm(){
        this.form.find('input, button').prop('disabled', false);
    }
    showprocessMessage(){
        this.button.html('<div class="busy-spinner-light"></div>');
    }
    removeprocessMessage(){
        this.button.html('SIGN UP');
    }
}
export default Newsletter;